import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import React, { FC, useEffect, useState } from 'react';
import { Close } from '@material-ui/icons';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

type MessageModalProps = {
  open: boolean
  onClose: () => void
}

export const MessageModal: FC<MessageModalProps> = (
  {
    open,
    onClose,
  },
) => {

  const classes = useStyles();

  const onModalClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onModalClose}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{
        square: true,
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant={'h5'}>
          Figyelem!
        </Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onModalClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
            Kedves Vásárlónk, felhívjuk figyelmét, hogy az Ivory White, Palo Santo Beige és a Dune Beige magasfényű Inomat Pro színeinket átmenetileg a hátoldalon fehér ellenhúzóval lehet rendelni. 
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onClose}
          color="secondary"
          variant={'contained'}
          size={'small'}
        >
          Rendben
        </Button>
      </DialogActions>
    </Dialog>
  );
};